import { toastr } from 'react-redux-toastr';
import { createGroundTruth } from '../../server/RestClients';

export const LABEL_DATA_LOADING = 'LABEL_DATA_LOADING';
export const LABEL_DATA_SUCCESS = 'LABEL_DATA_SUCCESS';
export const LABEL_DATA_FAILURE = 'LABEL_DATA_FAILURE';
export const SET_LABEL = 'SET_LABEL';
export const RESET_COUNT = 'RESET_COUNT';

export const labelPredictions = (label, predictions) => async (dispatch) => {
  dispatch({
    type: LABEL_DATA_LOADING,
  });
  try {
    await createGroundTruth(label, predictions);
    toastr.success('Sample stored', '', { timeOut: 600 });
    dispatch({
      type: LABEL_DATA_SUCCESS,
    });
  } catch (e) {
    toastr.error(
      'Failed to store ground truth',
      'You may already be using this snapshot. Or check if the agent is running'
    );
    dispatch({
      type: LABEL_DATA_FAILURE,
      payload: e,
    });
  }
};

export const setLabel =
  (label, index = 0) =>
  (dispatch) => {
    dispatch({
      type: SET_LABEL,
      payload: {
        index,
        value: label,
      },
    });
  };

export const resetCount = () => (dispatch) => {
  dispatch({
    type: RESET_COUNT,
  });
};
